import {Command} from './Command';
import {ResizeTierAction} from '../actions';
import {BuildFloorService} from '../../build-floor.service';
import {StageService} from '../../stage.service';

export class ResizeTierCommand extends Command<ResizeTierAction> {

  private action: ResizeTierAction;

  constructor(
    private buildFloorSrvc: BuildFloorService,
    private stage: StageService
  ) {
    super();
  }

  do(action: ResizeTierAction): void {
    this.action = action;
  }

  undo(): void {
    const {points, tierCustomId} = this.action;
    const tier = this.stage.getChildrenByPredicate(child => child.userData.customId === tierCustomId)[0];
    this.buildFloorSrvc.buildFloor({points}, tier.id);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/ResizeTierCommand.ts